/**
 * Composed settings menu with trigger button.
 *
 * Combines the settings button trigger with the settings menu content
 * in a complete Menu component.
 *
 * Uses a single trigger: the settings button itself is the Bloom trigger.
 */

import * as stylex from "@stylexjs/stylex";
import { useState } from "react";

import { Menu } from "@animus/primaris";

import { SettingsButton } from "../settings-button";
import { SettingsMenuContent } from "./settings-menu";

const styles = stylex.create({
  wrapper: {
    position: "relative",
    display: "inline-flex",
  },
});

export interface ComposedSettingsMenuProps {
  variant?: "default" | "nav";
  onSignOut?: () => void;
}

export function ComposedSettingsMenu({
  variant = "default",
  onSignOut,
}: ComposedSettingsMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const isNav = variant === "nav";

  return (
    <div {...stylex.props(styles.wrapper)}>
      <Menu.Root
        anchor={isNav ? "start" : "end"}
        direction={isNav ? "top" : "bottom"}
        onOpenChange={setIsOpen}
        open={isOpen}
      >
        <Menu.Container
          buttonRadius={isNav ? 10 : 8}
          buttonSize={isNav ? 36 : 28}
          menuRadius={12}
          menuWidth={160}
        >
          <Menu.Trigger>
            <SettingsButton variant={variant} />
          </Menu.Trigger>
          <SettingsMenuContent {...(onSignOut ? { onSignOut } : {})} />
        </Menu.Container>
      </Menu.Root>
    </div>
  );
}
